import React from "react";
import FileImage from "../assets/images/file.png";
import { ButtonBase, Typography } from "@material-ui/core";

function FileView(props) {
  return (
    <ButtonBase
      style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 16 }}
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        }
      }}
    >
      <div style={{ width: 70, height: 70 }}>
        <img src={FileImage} alt="Directory" style={{ width: "100%", height: "100%" }} />
      </div>
      <div>
        <Typography>{props.file.name}</Typography>
      </div>
    </ButtonBase>
  );
}

export default FileView;
